<section class="animated fadeIn bg-gray ">
    <div class="breadcrumbArea">
        <div class="container">
            <div class="row justify-content-between align-items-center">
                <div class="col">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a routerLink="/approval"> <i class="hdr-home"></i> </a></li>
                            <li class="breadcrumb-item active" aria-current="page">Initiate Delegation Request</li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="container mt15">
        <div class="row">
            <div class="col-md-12">  <p class="appHead mb-8">Employee/SAP ID</p></div>
            <div class="col-md-12">
                <div class="empSearch FormField2">
                    <p-autoComplete [(ngModel)]="brand" [suggestions]="filteredBrands" (completeMethod)="filterBrands($event)" [size]="30" [minLength]="1" placeholder="Search By Name or User ID" panelStyleClass="panelClass"></p-autoComplete>
                    <span class="hdr-search"></span>
                </div> 
            </div>
        </div>
    </div> -->

    <div class="container mt-24 mb30">
        <div class="row">
            <div class="col-md-3 col-sm-3 mb-24">
                <p class="appHead f-18 mb-12">Select Application(s)</p>
                <div class="whiteBox2">
                    <!-- <div class="inputArea">
                        <input type="text" name="search" [(ngModel)]="searchTxt" (keyup)="changeEvt()" placeholder="Type here to search" autocomplete="off" pInputText>
                        <span class="icon-search"></span>
                        <span class="hcl-close" [hidden]="closebtn" (click)="clearInput()"></span>
                    </div> -->
                    <div class="selecteDiv2">
                        <p class="appSelchead">1 Application Selected</p>
                        <ul class="selUl">
                            <li (click)="addSpocD()" [hidden]="!billing">
                                Billing Request
                            </li>
                            <li (click)="addSpocB()" [hidden]="!addApps">
                                Capex
                            </li>
                            <li (click)="addSpocA()" [hidden]="!addApps1">
                                Comp Planner
                            </li> 
                        </ul>
                    </div>
                    <p class="appSelchead bt-1">Application List</p>
                    <div class="leftSelectAll">
                        <ul class="selectRow">
                            <li>
                                <label class="checkbox-label-role customLabel"> 
                                    <input type="checkbox" class="check1" [(ngModel)]="mast" (change)="master()"> 
                                    <span class="checkbox-custom">Select All</span>
                                    <span class="customCheck"></span> 
                                </label>
                            </li>
                            <li (click)="addSpoc()" [hidden]="!selectApp"> 
                                <label class="checkbox-label-role customLabel"> 
                                    <input type="checkbox" [(ngModel)]="child1" (change)="child()"> 
                                    <span class="checkbox-custom">Capex</span>
                                    <span class="customCheck"></span> 
                                </label>
                            </li>
                            <li (click)="addSpoc1()" [hidden]="!selectApp1">
                                <label class="checkbox-label-role customLabel"> 
                                    <input type="checkbox" class="check1" [(ngModel)]="child2" (change)="child()"> 
                                    <span class="checkbox-custom">Comp Planner</span>
                                    <span class="customCheck"></span> 
                                </label>
                            </li>
                            <li (click)="addSpocD1()" [hidden]="!selectbilling">
                                <label class="checkbox-label-role customLabel"> 
                                    <input type="checkbox" [(ngModel)]="child3" (change)="child()"> 
                                    <span class="checkbox-custom">Billing Request</span>
                                    <span class="customCheck"></span> 
                                </label>
                            </li>
                            <li>
                                <label class="checkbox-label-role customLabel"> 
                                    <input type="checkbox" [(ngModel)]="child4" (change)="child()"> 
                                    <span class="checkbox-custom">CVCS-SSB</span>
                                    <span class="customCheck"></span> 
                                </label>
                            </li>
                            <li>
                                <label class="checkbox-label-role customLabel"> 
                                    <input type="checkbox" [(ngModel)]="child5" (change)="child()"> 
                                    <span class="checkbox-custom">Employee Stock Option Plan(ESOP)</span>
                                    <span class="customCheck"></span> 
                                </label>
                            </li>
                            <li>
                                <label class="checkbox-label-role customLabel"> 
                                    <input type="checkbox" [(ngModel)]="child6" (change)="child()"> 
                                    <span class="checkbox-custom">Exit Management</span>
                                    <span class="customCheck"></span> 
                                </label>
                            </li>
                            <li>
                                <label class="checkbox-label-role customLabel"> 
                                    <input type="checkbox" [(ngModel)]="child7" (change)="child()"> 
                                    <span class="checkbox-custom">GEO Joining Console</span>
                                    <span class="customCheck"></span> 
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> 
            <div class="col-md-9 col-sm-9">
                <div class="row mb-14">
                    <div class="col-md-4 col-sm-4">
                        <p class="appHead f-18">Provide Application wise Details</p>
                    </div>
                    <div class="col-md-8 col-sm-8">
                        <ul class="sameUl">
                            <li>Same for All:</li>
                            <li>
                                <label class="checkbox-label "> 
                                    <input type="checkbox"> 
                                    <span class="checkbox-custom"></span>
                                    <h4 class="checkText"> Role(s) </h4>
                                </label>
                            </li>
                            <li>
                                <label class="checkbox-label"> 
                                    <input type="checkbox" (click)="toggleDelegate()"> 
                                    <span class="checkbox-custom"></span>
                                    <h4 class="checkText">Delegate to </h4>
                                </label>
                            </li>
                            <li>
                                <label class="checkbox-label "> 
                                    <input type="checkbox" (click)="toggleDuration()"> 
                                    <span class="checkbox-custom"></span>
                                    <h4 class="checkText"> Duration </h4>
                                </label>
                            </li>
                            <li>
                                <label class="checkbox-label "> 
                                    <input type="checkbox" (click)="toggleRemarks()"> 
                                    <span class="checkbox-custom"></span>
                                    <h4 class="checkText"> Remarks </h4>
                                </label>
                            </li>
                            <li>
                                <p class="expColText" (click)="openAll()">
                                    <!-- <span (click)="txtTgl = !txtTgl">{{txtTgl ? "Collapse All" : "Expand All"}}</span> -->
                                    <span class="hdr-accordionDown"></span>
                                    <span class="hdr-accordionUp"></span>
                                </p>
                            </li>
                        </ul>                        
                    </div>
                </div>
                <div class="padding0 accordionTab">
                    <p-accordion [activeIndex]="index" expandIcon="pi pi-fw pi-chevron-down"  collapseIcon="pi pi-fw pi-chevron-up">
                        <p-accordionTab  [selected]="true">
                            <p-header class="headerA"> Billing Request (BRQ) 
                                  <span class="subHeader"> (2 roles selected) </span>
                            </p-header>
                            <ul class="provideDiv">
                                <li>
                                    <label class="checkbox-label "> 
                                        <input type="checkbox" [(ngModel)]="mastR" (change)="masterR()"> 
                                        <span class="checkbox-custom"></span>
                                        <h4 class="checkText tableHd"> Roles <span> (without Sub-Roles) </span> </h4>
                                    </label>
                                    <ul class="selectRow mb-30">
                                        <li>
                                            <label class="checkbox-label-role customLabel"> 
                                                <input type="checkbox" [(ngModel)]="role1" (change)="childR()"> 
                                                <span class="checkbox-custom"> Reporting Manager</span> 
                                                <span class="customCheck"></span> 
                                            </label>
                                        </li>
                                        <li>
                                            <label class="checkbox-label-role customLabel"> 
                                                <input type="checkbox" [(ngModel)]="role2" (change)="childR()"> 
                                                <span class="checkbox-custom"> Project Manager </span> 
                                                <span class="customCheck"></span> 
                                            </label>
                                        </li>
                                        <li>
                                            <label class="checkbox-label-role customLabel"> 
                                                <input type="checkbox" [(ngModel)]="role3" (change)="childR()"> 
                                                <span class="checkbox-custom">  SBU Head </span> 
                                                <span class="customCheck"></span> 
                                            </label>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <h4 class="checkText tableHd rolesHead"> Roles <span> (along with Sub-Roles) </span>
                                        <i class="icon-info" triggers="mouseenter:mouseleave" placement="bottom" container="body" [popover]="subRoleTemp"></i> </h4>
                                    <label class="checkbox-label "> 
                                        <input type="checkbox" [(ngModel)]="mastR1" (change)="masterR1()"> 
                                        <span class="checkbox-custom"></span>
                                        <h4 class="checkText tableHd grpLb"> Group LOB </h4>
                                    </label>
                                    <ul class="selectRow mb-30">
                                        <li>
                                            <label class="checkbox-label-role customLabel"> 
                                                <input type="checkbox" [(ngModel)]="lob1" (change)="childR1()"> 
                                                <span class="checkbox-custom">
                                                    EIS - DU1 (54919450)
                                                </span> <span class="customCheck"></span> </label>
                                        </li>
                                        <li>
                                            <label class="checkbox-label-role customLabel"> 
                                                <input type="checkbox" [(ngModel)]="lob2" (change)="childR1()"> 
                                                <span class="checkbox-custom">
                                                    BTIS – EIS (54919409)
                                                </span> <span class="customCheck"></span> </label>
                                        </li>
                                    </ul>
                                    </li>

                                <li>
                                    <label class="checkbox-label rolesHead customLabel"> 
                                        <input type="checkbox" [(ngModel)]="mastR2" (change)="masterR2()"> 
                                        <span class="checkbox-custom"></span>
                                        <h4 class="checkText tableHd grpLb"> BU Head </h4>
                                    </label>
                                    <ul class="selectRow mb-30">
                                        <li>
                                            <label class="checkbox-label-role customLabel"> 
                                                <input type="checkbox" [(ngModel)]="bu1" (change)="childR2()"> 
                                                <span class="checkbox-custom">
                                                    EIS-DU1 (54919450)
                                                </span><span class="customCheck"></span>  </label>
                                        </li>
                                    </ul>
                                </li>
                            </ul>


                            <div class="bootomSection">
                                <div class="row">
                                    <div class="col-md-4" [class.delegateHide]="delegateHideDiv">
                                        <label>Delegate To</label>
                                        <div class="empSearch FormField2">
                                            <p-autoComplete [(ngModel)]="brand" [suggestions]="filteredBrands" (completeMethod)="filterBrands($event)" [size]="30" [minLength]="1" placeholder="Search by Name or SAP ID" panelStyleClass="panelClass"></p-autoComplete>
                                            <span class="hdr-search"></span>
                                        </div> 
                                    </div>
                    
                                    <div class="col-md-8 col-sm-8 cstmDD calender" [class.durationHide]="durationHideDiv">
                                       <div class="row">
                                        <div class="col-md-6">
                                            <label>Duration</label>
                                            <div class="radioWarp">
                                                <div class="d-flex align-items-center radioBtn">
                                                    <p-radioButton name="Duration11" value="1-Months2" [(ngModel)]="ingredient" inputId="ingredient12"></p-radioButton>
                                                    <label for="ingredient1" class="">1 Month</label>
                                                </div>
                                                
                                                <div class="d-flex align-items-center radioBtn">
                                                    <p-radioButton name="Duration11" value="3-Months2" [(ngModel)]="ingredient" inputId="ingredient22"></p-radioButton>
                                                    <label for="ingredient2" class="">3 Month</label>
                                                </div>
                                                
                                                <div class="d-flex align-items-center radioBtn">
                                                    <p-radioButton name="Duration11" value="1-Years2" [(ngModel)]="ingredient" inputId="ingredient32"></p-radioButton>
                                                    <label for="ingredient3" class="">1 Year</label>
                                                </div>

                                            </div>
                                          </div>
                                          <div class="col-md-6">
                                            <div class="FormField calenderFild mt-26">
                                                <p-calendar appendTo="body" dateFormat="dd-M-y" [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true"  [showIcon]="true"></p-calendar>
                                            </div>
                                          </div>
                                       </div>
                                    </div>
                                </div>
                                <div class="row mt-16">
                                    <div class="col-md-12" [class.remarksHide]="remarksHideDiv">
                                        <div class="form-area text-center">
                                            <textarea class="form-control remarks" placeholder="Type here..."></textarea>
                                            <div class="mickWarp"><span class="hdr-mick"></span></div>
                                          </div>
                                    </div>
                                </div>
                            </div>

                        </p-accordionTab>
                    </p-accordion> 
                           
                    <p-accordion [activeIndex]="index" expandIcon="pi pi-fw pi-chevron-down" collapseIcon="pi pi-fw pi-chevron-up" >
                        <p-accordionTab>
                            <p-header class="headerA"> Global Claim (GCS)
                                <span class="subHeader"> (3 roles selected) </span>
                          </p-header>
                          <ul class="provideDiv">
                              <li>
                                  <label class="checkbox-label "> 
                                      <input type="checkbox" [(ngModel)]="mastR" (change)="masterR()"> 
                                      <span class="checkbox-custom"></span>
                                      <h4 class="checkText tableHd"> Roles <span> (without Sub-Roles) </span> </h4>
                                  </label>
                                  <ul class="selectRow mb-30">
                                      <li>
                                          <label class="checkbox-label-role customLabel"> 
                                              <input type="checkbox" [(ngModel)]="role1" (change)="childR()"> 
                                              <span class="checkbox-custom">
                                                  Reporting Manager
                                              </span> <span class="customCheck"></span> </label>
                                      </li>
                                      <li>
                                          <label class="checkbox-label-role customLabel"> 
                                              <input type="checkbox" [(ngModel)]="role2" (change)="childR()"> 
                                              <span class="checkbox-custom">
                                                  Project Manager
                                              </span> </label>
                                      </li>
                                      <li>
                                          <label class="checkbox-label-role customLabel"> 
                                              <input type="checkbox" [(ngModel)]="role3" (change)="childR()"> 
                                              <span class="checkbox-custom">
                                                  SBU Head
                                              </span><span class="customCheck"></span>  </label>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <h4 class="checkText tableHd rolesHead"> Roles <span> (along with Sub-Roles) </span> <i class="icon-info"></i> </h4>
                                  <label class="checkbox-label "> 
                                      <input type="checkbox" [(ngModel)]="mastR1" (change)="masterR1()"> 
                                      <span class="checkbox-custom"></span>
                                      <h4 class="checkText tableHd grpLb"> Group LOB <a>Select all Sub-Roles</a> </h4>
                                  </label>
                                  <ul class="selectRow mb-30">
                                      <li>
                                          <label class="checkbox-label-role customLabel"> 
                                              <input type="checkbox" [(ngModel)]="lob1" (change)="childR1()"> 
                                              <span class="checkbox-custom">
                                                  EIS - DU1 (54919450)
                                              </span><span class="customCheck"></span>  </label>
                                      </li>
                                      <li>
                                          <label class="checkbox-label-role customLabel"> 
                                              <input type="checkbox" [(ngModel)]="lob2" (change)="childR1()"> 
                                              <span class="checkbox-custom">
                                                  BTIS – EIS (54919409)
                                              </span><span class="customCheck"></span>  </label>
                                      </li>
                                  </ul>
                                  </li>

                              <li>
                                  <label class="checkbox-label rolesHead"> 
                                      <input type="checkbox" [(ngModel)]="mastR2" (change)="masterR2()"> 
                                      <span class="checkbox-custom"></span>
                                      <h4 class="checkText tableHd grpLb"> BU Head </h4>
                                  </label>
                                  <ul class="selectRow mb-30">
                                      <li>
                                          <label class="checkbox-label-role customLabel"> 
                                              <input type="checkbox" [(ngModel)]="bu1" (change)="childR2()"> 
                                              <span class="checkbox-custom">
                                                  EIS-DU1 (54919450)
                                              </span> <span class="customCheck"></span> </label>
                                      </li>
                                  </ul>
                              </li>
                          </ul>
                          <div class="bootomSection">
                            <div class="row">
                                <div class="col-md-4" [class.delegateHide]="delegateHideDiv">
                                    <label>Delegate To</label>
                                    <div class="empSearch FormField2">
                                        <p-autoComplete [(ngModel)]="brand" [suggestions]="filteredBrands" (completeMethod)="filterBrands($event)" [size]="30" [minLength]="1" placeholder="Search by Name or SAP ID" panelStyleClass="panelClass"></p-autoComplete>
                                        <span class="hdr-search"></span>
                                    </div> 
                                </div>
                
                                <div class="col-md-8 col-sm-8 cstmDD calender" [class.durationHide]="durationHideDiv">
                                   <div class="row">
                                    <div class="col-md-6">
                                        <label>Duration</label>
                                        <div class="radioWarp">
                                            <div class="d-flex align-items-center radioBtn">
                                                <p-radioButton name="Duration" value="1-Month" [(ngModel)]="ingredient" inputId="ingredient1"></p-radioButton>
                                                <label for="ingredient1" class="">1 Month</label>
                                            </div>
                                            
                                            <div class="d-flex align-items-center radioBtn">
                                                <p-radioButton name="Duration" value="3-Month" [(ngModel)]="ingredient" inputId="ingredient2"></p-radioButton>
                                                <label for="ingredient2" class="">3 Month</label>
                                            </div>
                                            
                                            <div class="d-flex align-items-center radioBtn">
                                                <p-radioButton name="Duration" value="1-Year" [(ngModel)]="ingredient" inputId="ingredient3"></p-radioButton>
                                                <label for="ingredient3" class="">1 Year</label>
                                            </div>

                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="FormField calenderFild mt-26">
                                            <p-calendar appendTo="body" dateFormat="dd-M-y" [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true"  [showIcon]="true"></p-calendar>
                                        </div>
                                      </div>
                                   </div>
                                </div>
                            </div>
                            <div class="row mt-16">
                                <div class="col-md-12" [class.remarksHide]="remarksHideDiv">
                                    <div class="form-area text-center">
                                        <textarea class="form-control remarks" placeholder="Type here..."></textarea>
                                        <div class="mickWarp"><span class="hdr-mick"></span></div>
                                      </div>
                                </div>
                            </div>
                        </div>
                        </p-accordionTab>
                    </p-accordion>
                    <p-accordion [activeIndex]="index" expandIcon="pi pi-fw pi-chevron-down" collapseIcon="pi pi-fw pi-chevron-up" >
                        <p-accordionTab>
                            <p-header class="headerA"> Time Sheet Management (iTime) 
                                <span class="subHeader"> (2 roles selected) </span>
                           </p-header>
                          <ul class="provideDiv">
                              <li>
                                  <label class="checkbox-label "> 
                                      <input type="checkbox" [(ngModel)]="mastR" (change)="masterR()"> 
                                      <span class="checkbox-custom"></span>
                                      <h4 class="checkText tableHd"> Roles <span> (without Sub-Roles) </span> </h4>
                                  </label>
                                  <ul class="selectRow mb-30">
                                      <li>
                                          <label class="checkbox-label-role customLabel"> 
                                              <input type="checkbox" [(ngModel)]="role1" (change)="childR()"> 
                                              <span class="checkbox-custom">
                                                  Reporting Manager
                                              </span> <span class="customCheck"></span> </label>
                                      </li>
                                      <li>
                                          <label class="checkbox-label-role customLabel"> 
                                              <input type="checkbox" [(ngModel)]="role2" (change)="childR()"> 
                                              <span class="checkbox-custom">
                                                  Project Manager
                                              </span><span class="customCheck"></span>  </label>
                                      </li>
                                      <li>
                                          <label class="checkbox-label-role customLabel"> 
                                              <input type="checkbox" [(ngModel)]="role3" (change)="childR()"> 
                                              <span class="checkbox-custom">
                                                  SBU Head
                                              </span><span class="customCheck"></span>  </label>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <h4 class="checkText tableHd rolesHead"> Roles <span> (along with Sub-Roles) </span> <i class="icon-info"></i> </h4>
                                  <label class="checkbox-label "> 
                                      <input type="checkbox" [(ngModel)]="mastR1" (change)="masterR1()"> 
                                      <span class="checkbox-custom"></span>
                                      <h4 class="checkText tableHd grpLb"> Group LOB <a>Select all Sub-Roles</a> </h4>
                                  </label>
                                  <ul class="selectRow mb-30">
                                      <li>
                                          <label class="checkbox-label-role customLabel"> 
                                              <input type="checkbox" [(ngModel)]="lob1" (change)="childR1()"> 
                                              <span class="checkbox-custom">
                                                  EIS - DU1 (54919450)
                                              </span> <span class="customCheck"></span> </label>
                                      </li>
                                      <li>
                                          <label class="checkbox-label-role customLabel"> 
                                              <input type="checkbox" [(ngModel)]="lob2" (change)="childR1()"> 
                                              <span class="checkbox-custom">
                                                  BTIS – EIS (54919409)
                                              </span> <span class="customCheck"></span> </label>
                                      </li>
                                  </ul>
                                  </li>

                              <li>
                                  <label class="checkbox-label rolesHead"> 
                                      <input type="checkbox" [(ngModel)]="mastR2" (change)="masterR2()"> 
                                      <span class="checkbox-custom"></span>
                                      <h4 class="checkText tableHd grpLb"> BU Head </h4>
                                  </label>
                                  <ul class="selectRow mb-30">
                                      <li>
                                          <label class="checkbox-label-role customLabel"> 
                                              <input type="checkbox" [(ngModel)]="bu1" (change)="childR2()"> 
                                              <span class="checkbox-custom">
                                                  EIS-DU1 (54919450)
                                              </span><span class="customCheck"></span>  </label>
                                      </li>
                                  </ul>
                              </li>
                          </ul>
                          <div class="bootomSection">
                            <div class="row">
                                <div class="col-md-4" [class.delegateHide]="delegateHideDiv">
                                    <label>Delegate To</label>
                                    <div class="empSearch FormField2">
                                        <p-autoComplete [(ngModel)]="brand" [suggestions]="filteredBrands" (completeMethod)="filterBrands($event)" [size]="30" [minLength]="1" placeholder="Search by Name or SAP ID" panelStyleClass="panelClass"></p-autoComplete>
                                        <span class="hdr-search"></span>
                                    </div> 
                                </div>
                
                                <div class="col-md-8 col-sm-8 cstmDD calender" [class.durationHide]="durationHideDiv">
                                   <div class="row">
                                    <div class="col-md-6">
                                         <label>Duration</label>
                                        <div class="radioWarp">
                                            <div class="d-flex align-items-center radioBtn">
                                                <p-radioButton name="Duration3" value="1-Months" [(ngModel)]="ingredient" inputId="ingredient11"></p-radioButton>
                                                <label for="ingredient1" class="">1 Month</label>
                                            </div>
                                            
                                            <div class="d-flex align-items-center radioBtn">
                                                <p-radioButton name="Duration3" value="3-Months" [(ngModel)]="ingredient" inputId="ingredient21"></p-radioButton>
                                                <label for="ingredient2" class="">3 Month</label>
                                            </div>
                                            
                                            <div class="d-flex align-items-center radioBtn">
                                                <p-radioButton name="Duration3" value="1-Years" [(ngModel)]="ingredient" inputId="ingredient31"></p-radioButton>
                                                <label for="ingredient3" class="">1 Year</label>
                                            </div>

                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="FormField calenderFild mt-26">
                                            <p-calendar appendTo="body" dateFormat="dd-M-y" [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true"  [showIcon]="true"></p-calendar>
                                        </div>
                                      </div>
                                   </div>
                                </div>
                            </div>
                            <div class="row mt-16">
                                <div class="col-md-12" [class.remarksHide]="remarksHideDiv">
                                    <div class="form-area text-center">
                                        <textarea class="form-control remarks" placeholder="Type here..."></textarea>
                                        <div class="mickWarp"><span class="hdr-mick"></span></div>
                                      </div>
                                </div>
                            </div>
                        </div>
                        </p-accordionTab>
                    </p-accordion>
                </div>
            </div>
        </div>
    </div>
</section>


<div class="text-center glb-btn pb-30 mt-30">
    <button class="btn secondry-button">Cancel</button>
    <button (click)="rejectModal.show()" type="button" class="btn primary-button">Submit</button>
</div>



<!-- Roles Popover  -->
<ng-template #revokeTemplate>
    <div class="Revoke provideDiv">
        <ul class="selectRow">
            <li>
                <label class="checkbox-label-role"> 
                    <input type="checkbox"> 
                    <span class="checkbox-custom">
                        CORP-HR-HEAD
                    </span> </label>
            </li>
            <li>
                <label class="checkbox-label-role"> 
                    <input type="checkbox"> 
                    <span class="checkbox-custom">
                        CUST-ROLE
                    </span> </label>
            </li>
            <li>
                <label class="checkbox-label-role"> 
                    <input type="checkbox"> 
                    <span class="checkbox-custom">
                        SBU-FIN    
                    </span> </label>
            </li>
            <li>
                <label class="checkbox-label-role"> 
                    <input type="checkbox"> 
                    <span class="checkbox-custom">
                        FIN-SUPER    
                    </span> </label>
            </li>
            <li>
                <label class="checkbox-label-role"> 
                    <input type="checkbox"> 
                    <span class="checkbox-custom">
                        FIN-REGION    
                    </span> </label>
            </li>
        </ul>
    </div>
</ng-template> 

<!-- along with Sub-Roles Popover info  -->
<ng-template #subRoleTemp>
    <div class="Revoke provideDiv">
        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
    </div>
</ng-template>

<!-- Reject Modal Box Start  -->
<div bsModal #rejectModal="bs-modal" class="modal fade myModal" tabindex="-1" role="dialog" aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-md">
    <div class="modal-content">
    <div class="modal-body d-flex justify-content-center">
        <div class="mCell text-center">
          <span class="alertIcon"> <i class="hdr-attention"></i> </span>
          <h3>Are you sure you want to submit request?</h3>
          <div class="glb-btn mt-40">
              <button (click)="rejectModal.hide();" class="btn secondry-button">No</button>
            <button  type="button" class="btn primary-button" (click)="rejectModal.hide(); openModal(approvedModal);">Yes</button>
          </div>
        </div>
    </div>
    </div>
    </div>
  </div> 
  
    <!-- Approve Modal Box Start  -->
    <ng-template #approvedModal>
      <div class="modal-body successModal">
          <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide(); hideSuccessMsg()">
              <span aria-hidden="true" class="visually-hidden">&times;</span>
            </button>
          <div class="mtable">
              <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="sucImg" />  </span>
            <p class="">Request has been submitted successfully.</p>
          </div>
      </div>
    </ng-template>